var $be9cae133bb9c811$exports = {};
$be9cae133bb9c811$exports = {
    "clear": `\u{C9C0}\u{C6B0}\u{AE30}`,
    "invalid": `(\u{C720}\u{D6A8}\u{D558}\u{C9C0} \u{C54A}\u{C74C})`,
    "loading": `\u{B85C}\u{B4DC} \u{C911}...`,
    "noResults": `\u{ACB0}\u{ACFC} \u{C5C6}\u{C74C}`,
    "valid": `(\u{C720}\u{D6A8})`
};


export {$be9cae133bb9c811$exports as default};
//# sourceMappingURL=ko-KR.module.js.map
